import { Dictionary } from 'src/app/core/model/dictionary';
import { User } from 'src/app/user/model/user';

export class AssessmentEdit
{
    public id = null;
    public name = '';
    public description = '';
    public active = true;
    public deleted = false;
    public type: any;
    public source: string = null;
    public documentMimeType: string = null;
    public documentName: string = null;
    public assessmentVersion: string = null;
    public documentId = 0;
    public file: any = null;
    public fields: string = null;
    public flags: any = [];
    public tasks: any = [];
    public serviceTypes: any = [];
    public channels: any = [];
    public needs: any = [];
    public sensitivities: Dictionary[] = [];
    public privateAssessment = false;
    public workflowOnly = false;
    public showMemberExtension = false;
    public users: User[] = [];
}

